<header class="docuty-page-header">
  <button *ngIf="showBack" mat-icon-button type="button" class="docuty-page-header__back"
    (click)="back.emit()" [matTooltip]="backTooltip ?? ''">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <div class="docuty-page-header__text">
    <div class="docuty-page-header__breadcrumb">
      <ng-content select="[docutyBreadcrumb]"></ng-content>
    </div>
    <div class="docuty-page-header__title-row">
      <h1 class="docuty-page-header__title">{{ title }}</h1>
      <help-button *ngIf="helpContextKey" [contextKey]="helpContextKey"></help-button>
    </div>
    <p *ngIf="subtitle" class="docuty-page-header__subtitle">{{ subtitle }}</p>
  </div>

  <div class="docuty-page-header__actions">
    <ng-content></ng-content>
  </div>
</header>
